//名称关联数据
export const PROVINCE_AND_CITIES = [
    {
        "馬尼拉 MANILA": ["岷東 ME", "岷中 MC", "岷西 MW", "Dumaguete"]
    }, {
        "宿務 CEBU": ["CEBU"]
    }, {
        "三寶顏 ZAMBOANGA": ["ZAMBOANGA"]
    }, {
        "莱特 LEYTE ": ["TACLOBAN", "PALO", "ORMOC"]
    }, {
        "保和島 BOHOL": ["TAGBILARAN"]
    }, {
        "納卯 DAVAO": ["DAVAO"]
    }, {
        "美骨 BICOL": ["TABACO"]
    }, {
        "邦邦牙 PAMPANGA": ["ANGELES"]
    }, {
        "依朗 ILOILO": ["ILOILO"]
    },
];

export const AREA_LIST_COLUMNS = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
        // width: '5%',
    },
    {
        title: '地区（省）',
        en_title: 'Region (province)',
        ch_title: '地区（省）',
        dataIndex: '地区（省）',
        editable: true,
        // width: '15%',
    },
    {
        title: '地区（市）',
        en_title: 'Region (city)',
        ch_title: '地区（市）',
        dataIndex: '地区（市）',
        editable: true,
        // width: '15%',
    },
    {
        title: '编号',
        ch_title: '编号',
        en_title: 'Number',
        dataIndex: '编号',
        editable: true,
        rules: [{ required: true, message: '编号不能为空' }],
    },
    {
        title: '名称',
        en_title: 'Name',
        ch_title: '名称',
        dataIndex: '名称',
        editable: true,
        // width: '15%',
    },
    {
        title: '状态',
        ch_title: '状态',
        en_title: 'Status',
        dataIndex: '状态',
        // width: '5%',
    },
];

//action相关
export const AREA_SELECT_PROVINCE = "AREA_SELECT_PROVINCE";
export const AREA_SELECT_CITY = "AREA_SELECT_CITY";